var SlugHelper = /** @class */ (function () {
    function SlugHelper() {
    }
    SlugHelper.sluggify = function (string) {
        return string.trim().replace(/ /g, '-').toLowerCase().replace(/[^a-z\d\xBF-\xFF\-]/g, '');
    };
    SlugHelper.trimDashes = function (string, mode) {
        if (mode === void 0) { mode = 'all'; }
        switch (mode) {
            case 'start':
                return string.replace(/^-+/g, '');
            case 'end':
                return string.replace(/-+$/g, '');
            default:
            case 'all':
                return string.replace(/^-+|-+$/g, '');
        }
    };
    SlugHelper.sanitizeInput = function (string) {
        return string.toLowerCase()
            .replace(' ', '-')
            .replace(/[^A-z\d\xBF-\xFF\-]/g, '');
    };
    return SlugHelper;
}());
export { SlugHelper };
